import PropTypes from "prop-types";

import GradeConverter from "../../utils/GradeConverter";
import StudentImage from "./StudentImage";
import T from "../translations/Translations";

import "../../styles/StudentInfoBlock.scss";

/**
 * A component that will render a grey box with student information within
 * @name EprStudentInfoBlock
 * @constructor
 * @param {func} setLoader
 * @param {{}} studentInfo
 * @returns {JSX.Element}
 */
const EprStudentInfoBlock = ({ setLoader, studentInfo }) => {
    const { address, firstName, gradeName, lastName, schoolName, studentNumber } = studentInfo;
    const gradeNumber = GradeConverter(gradeName);
    const hasAddress = Boolean(address?.addressLine1);

    return (
        <div className="student-block-container">
            <div className="photo-container">
                <StudentImage
                    className="ms-2 rounded-3"
                    height={165}
                    setLoader={setLoader}
                    studentInfo={studentInfo}
                    width={111}
                />
            </div>
            <div className="student-info-container">
                <div className="student-name">{`${firstName} ${lastName} (${studentNumber})`}</div>
                <table>
                    <tbody>
                        <tr>
                            <td height={10} width={80}>
                                {T({ key: "Student_Info_Grade" })}:
                            </td>
                            <td>
                                <i>{gradeNumber || "Unavailable"}</i>
                            </td>
                        </tr>
                        <tr>
                            <td height={10} width={80} valign="middle">
                                {T({ key: "Student_Info_School" })}:
                            </td>
                            <td>
                                <i>{schoolName || "Unavailable"}</i>
                            </td>
                        </tr>
                        <tr className="no-border">
                            <td width={80}>{T({ key: "Student_Info_Address" })}:</td>
                            <td>
                                <i>{hasAddress ? address.addressLine1 : "Unavailable"}</i>
                            </td>
                        </tr>
                        {hasAddress && address?.addressLine2 && (
                            <tr className="no-border">
                                <td>&nbsp;</td>
                                <td>
                                    <i>{address.addressLine2}</i>
                                </td>
                            </tr>
                        )}
                        {hasAddress && (
                            <tr className="no-border">
                                <td>&nbsp;</td>
                                <td>
                                    <i>
                                        {address?.city}, {address?.state} {address?.zip}
                                    </i>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

EprStudentInfoBlock.propTypes = {
    setLoader: PropTypes.func.isRequired,
    studentInfo: PropTypes.oneOfType([PropTypes.object]).isRequired
};

export default EprStudentInfoBlock;
